import React from "react";
import { FiUpload } from "react-icons/fi";

const IconExport = ({ color, borderColor }) => {
  return (
    <div className={`export-image__frame border-l ${borderColor}`}>
      <FiUpload
        className="export-image"
        alt="icon-download"
        style={{ color: { color } }}
      />
    </div>
  );
};

export default IconExport;
